import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=97900e84&"
import script from "./order-details.vue?vue&type=script&lang=ts&"
export * from "./order-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports